export type DraftStatusSnapshot = { id: string; status: string };

const activeOcrStatuses = new Set(['QUEUED', 'PROCESSING']);

export function hasActiveOcrDrafts(drafts: DraftStatusSnapshot[]) {
  return drafts.some((draft) => activeOcrStatuses.has(draft.status));
}
